import ApiServer from '@/utils/api/ApiServer.js'
import { compareGroupPrecedence } from '@/utils/dueDiligence/groupPrecedence.js'

let inFlight = null

export default {
  fetchMitigationGroups (context) {
    if (inFlight) return inFlight
    context.commit('setMitigationGroupsLoading', true)
    inFlight = ApiServer.get('mitigationGroups')
      .then(response => {
        const sortedData = response.data.sort(compareGroupPrecedence)
        context.commit('setMitigationGroups', sortedData)
        return sortedData
      })
      .finally(() => {
        context.commit('setMitigationGroupsLoading', false)
        inFlight = null
      })
    return inFlight
  },

  async deleteMitigationGroup (context, mitigationGroupId) {
    const response = await ApiServer.delete(`mitigationGroups/${mitigationGroupId}`)
    context.commit('removeMitigationGroup', mitigationGroupId)
    return response.data
  },

  async createMitigationGroup (context, mitigationGroup) {
    const response = await ApiServer.post('mitigationGroups', mitigationGroup)
    context.commit('addMitigationGroup', response.data)
    return response.data
  },

  async updateMitigationGroup (context, mitigationGroup) {
    const response = await ApiServer.put(`mitigationGroups/${mitigationGroup.mitigationGroupId}`, mitigationGroup)
    context.commit('updateMitigationGroup', response.data)
    return response.data
  },

  async reorderMitigationGroups (context, orderedIds) {
    const response = await ApiServer.put('mitigationGroups/priority', orderedIds)
    const sortedData = response.data.sort(compareGroupPrecedence)
    context.commit('setMitigationGroups', sortedData)
    return sortedData
  }
}
